
    var riot = require('riot')
    import { MoreRefinements } from './gb-more-refinements';
riot.tag2('gb-more-refinements', '<yield> <a onclick="{loadMore}">More</a> </yield>', 'gb-more-refinements.gb-stylish a,[data-is="gb-more-refinements"].gb-stylish a{ cursor: pointer; color: #777; text-decoration: underline; } gb-more-refinements.gb-stylish a:hover,[data-is="gb-more-refinements"].gb-stylish a:hover{ color: black; }', '', function(opts) {
    this._mixin(MoreRefinements);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/navigation/gb-more-refinements.tag.html